import React from "react";
import driveDirectBooking from "../../assets/images/hospitality/drive-direct-bookings.png";

const Intro = () => {
  return (
    <section className="tw-py-20 lg:tw-py-24 tw-bg-white">
      <div className="tw-max-w-6xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-12 lg:tw-gap-16 tw-items-center">
          
          {/* Image Column */}
          <div className="tw-relative">
            <div className="hero-img-glow tw-opacity-20 tw-blur-xl" />
            <img
              src={driveDirectBooking}
              alt="Drive Direct Bookings Effortlessly"
              className="tw-w-full tw-h-auto tw-object-contain img-shadow-indigo tw-rounded-2xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300"
              loading="lazy"
            />
          </div>

          {/* Text Column */}
          <div className="tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Drive Direct Bookings Effortlessly
            </h2>
            <p className="tw-text-sm sm:tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-6">
              In the competitive hospitality industry, attracting and retaining guests requires highly targeted marketing strategies and effective lead generation.
            </p>
            <p className="tw-text-sm sm:tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-0">
              BeyondLeadz is designed to help hotels, resorts, and travel businesses reach the right audience, convert more leads, and enhance guest loyalty through personalized marketing efforts.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Intro;
